import { useMemo } from 'react';
import { WorkSchedule } from '@duke-hq/shared-constants/enrolments';
import { djs } from '@duke-hq/djs';

export const useSemesterEndDate = ({
  workSchedule,
  startAt,
}: {
  workSchedule: string;
  startAt: Date | string;
}) => {
  return useMemo(() => {
    let weeks;

    if (workSchedule === WorkSchedule.PART_TIME.toString()) {
      weeks = 26;
    } else if (workSchedule === WorkSchedule.FULL_TIME.toString()) {
      weeks = 13;
    }

    return djs(startAt).add(weeks, 'week');
  }, [workSchedule, startAt]);
};
